import { InventoryReportSnapshotItemRow } from './types';

export const COLUMN_IDS = [
    'description',
    'supplier',
    'location',
    'onHandQuantity',
    'reorderLevel',
    'maxOrderLevel',
    'orderQtyToPlace',
    'quantityInCase',
    'anyShort',
    'receivedLast',
    'sales30Days',
    'sales60Days',
    'sales90Days',
    'sales180Days',
    'lastPurchasePrice',
    'retailPrice',
    'profitMargin',
    'onOrder',
] as const;

export type ColumnId = typeof COLUMN_IDS[number];

export const SORTABLE_COLUMN_IDS: ColumnId[] = ['description', 'supplier'];

export interface ColumnDef {
    id: ColumnId;
    header: string;
    width: number;
    minWidth: number;
    align: 'left' | 'center' | 'right';
    sticky?: boolean;
    stickyLeft?: number;
}

const DESCRIPTION_WIDTH = 320;
export const COLUMNS: ColumnDef[] = [
    { id: 'description', header: 'Description', width: DESCRIPTION_WIDTH, minWidth: DESCRIPTION_WIDTH, align: 'left', sticky: true, stickyLeft: 0 },
    { id: 'supplier', header: 'Supplier', width: 200, minWidth: 200, align: 'left', sticky: true, stickyLeft: DESCRIPTION_WIDTH },
    { id: 'location', header: 'Location', width: 150, minWidth: 150, align: 'left', sticky: true, stickyLeft: DESCRIPTION_WIDTH + 200 },
    { id: 'onHandQuantity', header: 'On-Hand Qty', width: 100, minWidth: 100, align: 'center' },
    { id: 'reorderLevel', header: 'Reorder Level', width: 100, minWidth: 100, align: 'center' },
    { id: 'maxOrderLevel', header: 'Max Order Level', width: 100, minWidth: 100, align: 'center' },
    { id: 'orderQtyToPlace', header: 'Order Qty', width: 100, minWidth: 100, align: 'center' },
    { id: 'quantityInCase', header: 'Qty in Case', width: 100, minWidth: 100, align: 'center' },
    { id: 'anyShort', header: 'Short Stock', width: 100, minWidth: 100, align: 'center' },
    { id: 'receivedLast', header: 'Received Last', width: 100, minWidth: 100, align: 'center' },
    { id: 'sales30Days', header: 'Sales 30 Days', width: 100, minWidth: 100, align: 'center' },
    { id: 'sales60Days', header: 'Sales 60 Days', width: 100, minWidth: 100, align: 'center' },
    { id: 'sales90Days', header: 'Sales 90 Days', width: 100, minWidth: 100, align: 'center' },
    { id: 'sales180Days', header: 'Sales 180 Days', width: 100, minWidth: 100, align: 'center' },
    { id: 'lastPurchasePrice', header: 'Last Purchase $', width: 100, minWidth: 100, align: 'center' },
    { id: 'retailPrice', header: 'Retail Price', width: 100, minWidth: 100, align: 'center' },
    { id: 'profitMargin', header: 'Profit Margin %', width: 100, minWidth: 100, align: 'center' },
    { id: 'onOrder', header: 'On Order', width: 100, minWidth: 100, align: 'center' },
];
